import { INSURANCE_TYPES } from "@global/const";

export const modBlocks = {
    description: 'Описание'
}
const modFields = {
    img: {default: '', options:  {type: 'imgEdit', imgType: 'clinics', path:'/storage.public/images/clinics/150x150/'}},
    area: {default: '', options: {type: 'selectDict', store: 'areaOptions', prefix: 'Округ', filter: {city: ''}}},
    locality: {default: '', options: {type: 'selectDict', store: 'localityOptions', prefix: 'Нас.пункт', filter: {city: ''}}},
    district: {default: '', options: {type: 'selectDict', store: 'districtOptions', prefix: 'Район', filter: {}}},
    address: {default: '', options: {type: 'text', prefix: 'Адрес', ymaps: true}},
    photos: {default: [], options: {
        type: 'photos',
        path: '/storage.public/images/clinicPhotos/120x120/',
        preset: 'photo',
        uploadUrl: '/admin/clinics/uploadPhoto',
        buttonText: 'Добавить<br>фотографии<br>клиники',
    }},
    nameOfficial: {default: '', options: {type: 'text', prefix: 'Оф назв'}},
    licenceNum: {default: '', options: {type: 'text', prefix: '№ лиц'}},
    registryPhone: {default: '', options: {type: 'phone', prefix: 'Тел.рег'}},
    email: {default: '', options: {type: 'text', prefix: 'Email', rules: 'email'}},
    proprietary: {default: '', options: {type: 'hide'}},
    website: {default: '', options: {type: 'text', prefix: 'Сайт', rules: 'clinicAnyOfSixMod'}},
    socialVk: {default: '', options: {type: 'text', prefix: 'Vk', rules: 'socialVk|clinicAnyOfSixMod'}},
    socialOk: {default: '', options: {type: 'text', prefix: 'Ok', rules: 'socialOk|clinicAnyOfSixMod'}},
    socialYoutube: {default: '', options: {type: 'text', prefix: 'Youtube', rules: 'socialYoutube|clinicAnyOfSixMod'}},
    socialTg: {default: '', options: {type: 'text', prefix: 'Tg', rules: 'socialTg|clinicAnyOfSixMod'}},
    socialWhatsApp: {default: '', options: {type: 'phone', prefix: 'WhatsApp', rules: 'clinicAnyOfSixMod'}},
    chiefDoctor: {default: '', options: {type: 'text', prefix: 'Глав врач'}},
    estYear: {default: '', options: {type: 'text', prefix: 'Год осн', rules:'numeric|min_value:1900|max_value:' + currentYear()}},
    insuranceType: {default: '', options: {type: 'select', prefix: 'Страховка', options: INSURANCE_TYPES}},
    hasTerminal: {default: 0, options: {type: 'checkbox', label: 'Есть оплата картой'}},
    hasHospital: {default: 0, options: {type: 'checkbox', label: 'Есть стационар'}},
    hasLaboratory: {default: 0, options: {type: 'checkbox', label: 'Есть лаборатория'}},
    hasParking: {default: 0, options: {type: 'checkbox', label: 'Есть парковка'}},
    licences: {default: [], options: {
            type: 'photos',
            path:'/storage.public/images/clinicLicences/Wx120/',
            preset: 'licence',
            uploadUrl: '/admin/clinics/uploadLicence',
            buttonText: 'Добавить<br>лицензии',
    }},
    description: {default: '', options: {type: 'html', block:'description', entity: 'clinic'}},
    markLat: {default: 0, options: {}},
    markLong: {default: 0, options: {}},
    mapZoom: {default: 16, options: {}},
}

export function modDefault()
{
    return _.mapValues(modFields, function (o) {
        return o.default;
    });
}

export function modOptions()
{
    const options = [];
    Object.keys(modFields).forEach(function (key, index) {
        options[index] = modFields[key].options;
        options[index].key = key;
    })
    return options;
}

export function currentYear() {
    return new Date().getFullYear() ?? 2400;
}
